import { exp } from "./export";
import { settings } from "../settings";
import { beads } from "../beads";
import { lang } from "../lang";

exp.getTriangleStrips = () => {
    let result = {
        stripNumber: 1,
        startColumn: 0,
        endColumn: settings.rows * 2,
        width: settings.rows * 2,
        rows: [] // contains the bead data!
    };

    let myRows = settings.rows * 2;

    let myTest = (bead, i, j, even) => {
        if (bead.tri !== undefined) {
            if (bead.tri.panel == j) {
                if ((bead.tri.column - 1) == i) {
                    if ((bead.tri.row % 2 == 0) == even) {
                        return true;
                    }
                }
            }
        }
        return false;
    };
    let r;
    for (let i = myRows; i > -myRows; i--) {
        r = [];
        for (let j = 0; j < 3; j++) { // 3 panels
            beads.arr.forEach(bead => {
                if (myTest(bead, i, j, true)) {
                    r.push(exp.getNewBead(bead));
                }
            });
        }
        if (r.length) {
            result.rows.push(r);
        }
        r = [];
        for (let j = 0; j < 3; j++) { // 3 panels
            beads.arr.forEach(bead => {
                if (myTest(bead, i, j, false)) {
                    r.push(exp.getNewBead(bead));
                }
            });
        }
        if (r.length) {
            result.rows.push(r);
        }
    }

    // put the last bead at the beginning of the row, except the last row.
    result.rows.forEach((r, index) => {
        if (index < result.rows.length - 1) {
            r.unshift(r.pop());
        }
    });

    exp.offsetPattern = new Array(15).fill(0);

    return [result];
};


exp.getTriangleWordChart = strip => {
    let result = {text: []};
    let myRow = [], myChunk, chunkInBrackets;
    exp.hasBlanks = false;

    strip.rows.forEach((row, i) => {
        myRow = [];

        let lastRow = i == strip.rows.length - 1;

        let lastRowDeduction = lastRow ? -2 : 0; // the last row is actually shorter!

        let rowNumber = i + 1;
        let rowLength = rowNumber + lastRowDeduction;
        result.text.push(lang.caps(lang.get('row')) + ' ' + + rowNumber.toString() + ': \n');

        for (let j = 0; j < 3; j++) {

            if (i == 0) {
                if (j == 0) {
                    myRow.push('‎\t(');
                    myChunk = exp.parseRow(row);
                    myChunk.forEach(element => {
                        myRow.push(element);
                    });
                    myRow.push(')\n');
                }
                continue;
            } else if (i == 1) {
                chunkInBrackets = exp.parseRow(row.slice(j * rowLength, j * rowLength + 2));
                myChunk = [];
            } else if (lastRow) {
                chunkInBrackets = [];
                myChunk = exp.parseRow(row.slice(j * rowLength, (j + 1) * rowLength));
            } else {
                chunkInBrackets = exp.parseRow(row.slice(j * rowLength, j * rowLength + 2));
                myChunk = exp.parseRow(row.slice(j * rowLength + 2, (j + 1) * rowLength));
            }

            if (!lastRow) {
                myRow.push('‎\t(');

                chunkInBrackets.forEach(element => {
                    myRow.push(element);
                });

                myRow.push(')');
                if (i !== 1) {
                    myRow.push(', ');
                }
            }
            if (lastRow) myRow.push('‎\t');
            myChunk.forEach(element => {
                myRow.push(element);
            });

            myRow.push('\n');
        }

        myRow.forEach(element => {
            result.text.push(element);
        });
    });

    if (exp.hasBlanks) result.text.push({
        text: '\n* = ' + lang.get('space between beads explanation on pdf export', 'space between beads')
    });

    return result;
};
